import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://vettis.ai';
const DEFAULT_TITLE = "Vettis - Don't Guess | The High-Stake Decision Engine";
const DEFAULT_DESCRIPTION = "Don't Guess. Vettis. The high-stake decision engine for investments, portfolio analysis, and business strategy. Multiple AI agents debate, verify, and deliver answers you can act on. Try it free.";
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`;

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  noindex?: boolean;
}

export function SEO({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION, path = '/', noindex = false }: SEOProps) {
  const canonical = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={DEFAULT_IMAGE} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
    </Helmet>
  );
}
